import React, { useState } from "react";

// Geographic tilegram layout for US + DC (row, col) — editorial style, à la FiveThirtyEight
const GRID = [
  { code: "AK", r: 0, c: 0 },
  { code: "ME", r: 0, c: 10 },
  { code: "VT", r: 1, c: 9 }, { code: "NH", r: 1, c: 10 },
  { code: "WA", r: 1, c: 1 }, { code: "ID", r: 1, c: 2 }, { code: "MT", r: 1, c: 3 }, { code: "ND", r: 1, c: 4 }, { code: "MN", r: 1, c: 5 }, { code: "WI", r: 1, c: 6 }, { code: "MI", r: 1, c: 7 }, { code: "NY", r: 1, c: 8 }, { code: "MA", r: 1, c: 9, override: false },
  { code: "OR", r: 2, c: 1 }, { code: "NV", r: 2, c: 2 }, { code: "WY", r: 2, c: 3 }, { code: "SD", r: 2, c: 4 }, { code: "IA", r: 2, c: 5 }, { code: "IL", r: 2, c: 6 }, { code: "IN", r: 2, c: 7 }, { code: "OH", r: 2, c: 8 }, { code: "PA", r: 2, c: 9 }, { code: "NJ", r: 2, c: 10 }, { code: "CT", r: 2, c: 11 }, { code: "RI", r: 2, c: 12 },
  { code: "CA", r: 3, c: 1 }, { code: "UT", r: 3, c: 2 }, { code: "CO", r: 3, c: 3 }, { code: "NE", r: 3, c: 4 }, { code: "MO", r: 3, c: 5 }, { code: "KY", r: 3, c: 6 }, { code: "WV", r: 3, c: 7 }, { code: "VA", r: 3, c: 8 }, { code: "MD", r: 3, c: 9 }, { code: "DE", r: 3, c: 10 },
  { code: "AZ", r: 4, c: 2 }, { code: "NM", r: 4, c: 3 }, { code: "KS", r: 4, c: 4 }, { code: "AR", r: 4, c: 5 }, { code: "TN", r: 4, c: 6 }, { code: "NC", r: 4, c: 7 }, { code: "SC", r: 4, c: 8 }, { code: "DC", r: 4, c: 9 },
  { code: "HI", r: 5, c: 0 }, { code: "OK", r: 5, c: 4 }, { code: "LA", r: 5, c: 5 }, { code: "MS", r: 5, c: 6 }, { code: "AL", r: 5, c: 7 }, { code: "GA", r: 5, c: 8 },
  { code: "TX", r: 6, c: 4 }, { code: "FL", r: 6, c: 8 },
];

const STATUS_STYLES = {
  legal:      { bg: "hsl(var(--legal-ok) / 0.9)",  label: "Legal" },
  regulated:  { bg: "hsl(var(--legal-reg) / 0.9)", label: "Legal w/ permit" },
  restricted: { bg: "hsl(var(--legal-res) / 0.9)", label: "Illegal (grandfathered)" },
  banned:     { bg: "hsl(var(--legal-ban) / 0.95)", label: "Illegal" },
};

export default function UsStateMap({ states, selected, onSelect }) {
  const [hover, setHover] = useState(null);

  return (
    <div className="w-full">
      <div className="grid gap-1.5" style={{ gridTemplateColumns: "repeat(13, minmax(0, 1fr))" }}>
        {Array.from({ length: 13 * 7 }).map((_, i) => {
          const r = Math.floor(i / 13);
          const c = i % 13;
          const s = GRID.find(g => g.r === r && g.c === c);
          if (!s) return <div key={i} />;
          const info = states?.[s.code];
          const status = info?.status || "legal";
          const style = STATUS_STYLES[status];
          const isSel = selected === s.code;
          const isHov = hover === s.code;
          return (
            <button
              key={s.code}
              onMouseEnter={() => setHover(s.code)}
              onMouseLeave={() => setHover(null)}
              onClick={() => onSelect?.(s.code)}
              data-testid={`state-tile-${s.code}`}
              className={
                "aspect-square rounded-md border flex items-center justify-center text-[10px] md:text-xs font-semibold tracking-wider transition-all " +
                (isSel ? "ring-2 ring-accent scale-105 " : "") +
                (isHov ? "scale-105 " : "") +
                "text-white/95 hover:brightness-110"
              }
              style={{ backgroundColor: style.bg, borderColor: "hsl(var(--border))" }}
              title={info?.name}
            >
              {s.code}
            </button>
          );
        })}
      </div>
      <div className="mt-6 flex flex-wrap items-center gap-4 text-xs text-muted-foreground">
        {Object.entries(STATUS_STYLES).map(([k, v]) => (
          <span key={k} className="inline-flex items-center gap-2">
            <span className="inline-block h-3 w-3 rounded" style={{ backgroundColor: v.bg }} /> {v.label}
          </span>
        ))}
      </div>
    </div>
  );
}
